<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="İçerik"
      label-for="content"
    >
      <quill-editor
        id="content"
        v-model="itemData.translate.content"
        class="bg-white"
        :options="editorOption"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.content" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Alt Başlık"
      label-for="subtitle"
    >
      <b-form-input
        id="subtitle"
        v-model="itemData.translate.subtitle"
        placeholder="Alt Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.subtitle }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin Alanı"
      label-for="text1"
    >
      <b-form-textarea
        id="text1"
        v-model="itemData.translate.text1"
        placeholder="Metin Alanı"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.text1" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin Alanı"
      label-for="text2"
    >
      <b-form-textarea
        id="text2"
        v-model="itemData.translate.text2"
        placeholder="Metin Alanı"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.text2" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Misyonumuz"
      label-for="mission"
    >
      <b-form-textarea
        id="mission"
        v-model="itemData.translate.mission"
        placeholder="Misyonumuz"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.mission" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Vizyonumuz"
      label-for="vision"
    >
      <b-form-textarea
        id="vision"
        v-model="itemData.translate.vision"
        placeholder="Vizyonumuz"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.vision" />
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton, BFormTextarea,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'About',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
    BFormTextarea,
    quillEditor,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
